import { CommonCodeCondition, Code } from 'models/common/CommonCode';
import {
  CommonRequest,
  Method,
  ServiceName,
  CommonResponse,
  DmlResponse,
} from 'models/common/RestApi';
import { MpMcrcList, SearchParam } from 'models/mp/MpMcrc';
import { callApi } from 'utils/ApiUtil';

/**
 * 분과위원관리 List 조회
 * @param searchParam
 */
export const getMpMcrcList = async (searchParam: SearchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/getMpMcrcList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<MpMcrcList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MpMcrcList[];
};

/**
 * 분과위원관리 List 입력/수정/삭제
 * @param searchParam
 */
export const saveMpMcrcList = async (saveData: MpMcrcList[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/mp/saveMpMcrcList`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: saveData,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as DmlResponse;
};

/**
 * 분과위원관리 PopUp List 조회
 * @param searchParam
 */
export const getMpMcrcPopUpList = async (searchParam: SearchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/getMpMcrcPopUpList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<MpMcrcList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MpMcrcList[];
};
